import React from 'react';
import { Skeleton, SkeletonKanban } from '../Skeleton';
import { useTheme } from '../../contexts/ThemeContext';

/**
 * Antes desta tela mostrar skeleton, ela renderizava os 6 cards com `0` e
 * `R$ 0,00` e um kanban vazio durante a carga — dado falso, indistinguível
 * de um dia sem pedidos.
 */
export default function PedidosSkeleton() {
  const { darkMode } = useTheme();
  return (
    <>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-3 mb-4">
        {Array.from({ length: 6 }).map((_, i) => (
          <div
            key={i}
            className={`rounded-lg p-3 border ${
              darkMode ? 'bg-zinc-800 border-zinc-700' : 'bg-white border-gray-200'
            }`}
          >
            <Skeleton className="h-2.5 w-3/5 mb-2" />
            <Skeleton className="h-7 w-2/3" />
          </div>
        ))}
      </div>
      <div className="flex-1 min-h-0">
        <SkeletonKanban colunas={4} cardsPorColuna={2} />
      </div>
    </>
  );
}
